import { Box, Flex, Text } from '@chakra-ui/react';
import { Check } from 'lucide-react';
import type { ReactNode } from 'react';

interface CheckItemProps {
  icon?: 'check' | 'ethernet';
  label: ReactNode;
  description?: string;
}

const EthernetIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 13V11C4 9.89543 4.89543 9 6 9H18C19.1046 9 20 9.89543 20 11V13" />
    <rect x="6" y="13" width="3" height="5" fill="currentColor" stroke="none" />
    <rect x="10.5" y="13" width="3" height="5" fill="currentColor" stroke="none" />
    <rect x="15" y="13" width="3" height="5" fill="currentColor" stroke="none" />
  </svg>
);

export const CheckItem: React.FC<CheckItemProps> = ({
  icon = 'check',
  label,
  description,
}) => {
  const isFilledCircle = icon === 'check';

  const renderIcon = () => {
    if (isFilledCircle) {
      return (
        <Flex
          align="center"
          justify="center"
          w="22px"
          h="22px"
          minW="22px"
          borderRadius="full"
          bg="green.600"
          color="white"
        >
          <Check size={14} strokeWidth={3} />
        </Flex>
      );
    }
    // Ethernet gets plain icon
    return (
      <Box color="green.600" minW="22px" display="flex" alignItems="center" justifyContent="center">
        <EthernetIcon />
      </Box>
    );
  };

  return (
    <Flex align="flex-start" gap={3} py={1}>
      {renderIcon()}
      <Box>
        <Text fontSize="sm" color="gray.800" fontWeight={description ? 'semibold' : 'normal'}>
          {label}
        </Text>
        {description && (
          <Text fontSize="sm" color="gray.600">
            {description}
          </Text>
        )}
      </Box>
    </Flex>
  );
};
